import {Paper, Typography} from "@mui/material";
import moment from "moment";
import FORMATS from "../constants/Formats";
import {useTranslation} from "react-i18next";

const QuizResults = ({results}) => {
    const {t} = useTranslation();

    const startDateStr = moment(results["date_start"]).format(FORMATS.DATE_TIME);
    const endDateStr = moment(results["date_end"]).format(FORMATS.DATE_TIME);

    return (
        <Paper elevation={3} sx={{p: 1}}>
            <Typography variant="h6">{t("last_quiz_results")}</Typography>
            <Typography>{t("score")}: {results["score"].toFixed(1)} ({Math.round(results["score_percent"])}%)</Typography>
            <Typography>{t("subcategories")}: {results["subcategories_str"]}</Typography>
            <Typography>{t("started_at")}: {startDateStr}</Typography>
            <Typography>{t("finished_at")}: {endDateStr}</Typography>
        </Paper>
    );
}

export default QuizResults;